import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsRadio from '../ManageContractsRadioCheckbox';

export const HouseType: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { houseType } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepHouseTypeElectricityAmount">
      <h3>{t('manageContracts:manageContracts.HouseTypeTitle')}*</h3>

      <div className="form-items houseType">
        <ManageContractsRadio
          radioID="manageContractsHouseTypeFlat"
          radioName="manageContractsHouseType"
          extraClass="house-flat"
          onChangeFunc={(): void => dispatch(['changeHouse', 'flat'])}
          checkedComparison={houseType === 'flat'}
          label={
            <div>
              <span>{t('manageContracts:manageContracts.HouseTypeFlat')}</span>
            </div>
          }
        />

        <ManageContractsRadio
          radioID="manageContractsHouseTypeRow"
          radioName="manageContractsHouseType"
          extraClass="house-row"
          onChangeFunc={(): void => dispatch(['changeHouse', 'row'])}
          checkedComparison={houseType === 'row'}
          label={
            <div>
              <span>{t('manageContracts:manageContracts.HouseTypeRow')}</span>
            </div>
          }
        />

        <ManageContractsRadio
          radioID="manageContractsHouseTypeDetached"
          radioName="manageContractsHouseType"
          extraClass="house-detached"
          onChangeFunc={(): void => dispatch(['changeHouse', 'detached'])}
          checkedComparison={houseType === 'detached'}
          label={
            <div>
              <span>{t('manageContracts:manageContracts.HouseTypeDetached')}</span>
            </div>
          }
        />

        <ManageContractsRadio
          radioID="manageContractsHouseTypeDetachedElectricHeating"
          radioName="manageContractsHouseType"
          extraClass="house-detached house-detached-electric-heating"
          onChangeFunc={(): void => dispatch(['changeHouse', 'detached-electric-heating'])}
          checkedComparison={houseType === 'detached-electric-heating'}
          label={
            <div>
              <span>{t('manageContracts:manageContracts.HouseTypeDetachedElectricHeating')}</span>
            </div>
          }
        />

        <ManageContractsRadio
          radioID="manageContractsHouseTypeCottage"
          radioName="manageContractsHouseType"
          extraClass="house-cottage"
          onChangeFunc={(): void => dispatch(['changeHouse', 'cottage'])}
          checkedComparison={houseType === 'cottage'}
          label={
            <div>
              <span>{t('manageContracts:manageContracts.HouseTypeCottage')}</span>
            </div>
          }
        />
      </div>
    </section>
  );
};

export default HouseType;
